import { colors } from '../../colors';
var anchor = {
  anchorColor: colors.dustyTeal
};
export default anchor;